import React from 'react'

function ColorBar() {
  return (
    <div className="container">
      <div className="layout">
        <div className="color-bar color-bar--purple-dark"></div>
        <div className="color-bar color-bar--purple"></div>
        <div className="color-bar color-bar--green"></div>
        <div className="color-bar color-bar--green-dark"></div>
      </div>
    </div>
  )
}

export default ColorBar;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Color-Bar.js